import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(85vh - 50px);
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px; 
  margin-right: -8px; 
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 24px 0 24px; 
`;

export const FixedFooter = styled.div`
  padding: 16px 24px 24px 24px; 
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;
  
  &:last-child {
    border-bottom: none;
    font-weight: 600;
  }
`;

export const Label = styled.span`
  color: #333;
  font-size: 14px;
`;

export const Value = styled.span`
  color: #333;
  font-weight: 500;
  font-size: 14px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`;
